import { Navigate, Outlet } from "react-router-dom";

export default function RedirectIfAuth() {
  const token = localStorage.getItem("access");

  if (token) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />; // <-- This renders the child route like <LoginPage />
}